module.exports = __webpack_public_path__ + "img/past-draws-winners.0157d0f5.png";